export default __webpack_public_path__ + "static/media/book.8e7fa150.png";